import React from 'react';
import { Form, Button } from 'react-bootstrap';
import AuthService from './../../services/AuthService';
import "./styles.scss";

class LoginForm extends React.Component {

    state = {
        login: null,
        password: null,
        mode: "login",
        errorMessage: null
    }

    mainAction = (event) => {
        event.preventDefault();

        if (!this.state.login || (this.state.login === "")) {
            this.setState({ invalidLogin: true });
            return;
        }

        if (this.state.mode === "recover") {
            this.setState({ errorMessage: null }, () => {
                AuthService.performRecoverAuth(this.state.login, (result) => {
                    if (result.status === AuthService.STATUS_ERROR) {
                        this.setState({ errorMessage: result.message });
                    }
                    else {
                        this.setState({ errorMessage: "Откройте ссылку из письма и создайте новый пароль" });
                    }
                });
            });
        }
        else {
            if (!this.state.password || (this.state.password === "")) {
                this.setState({ invalidPassword: true });
                return;
            }

            this.setState({ errorMessage: null }, () => {
                AuthService.performEmailAuth(this.state.login, this.state.password, (result) => {
                    if (result.status === AuthService.STATUS_ERROR) {
                        this.setState({ errorMessage: result.message });
                    }
                    else {
                        this.props.afterLogin();
                    }
                });
            });
        }
    }

    render() {
        return (
            <div className="loginForm">

                <p className="header">{this.state.mode === "login" ? "Вход на сайт" : (this.state.mode === "register" ? "Регистрация" : "Сброс пароля")}</p>
                <Form onSubmit={this.mainAction}>
                    <Form.Control
                        type="text"
                        className={"formInput" + (this.state.invalidLogin ? " invalid" : "")}
                        placeholder="e-mail"
                        onChange={(event) => { this.setState({ login: event.target.value, invalidLogin: false }); }}
                    />
                    {(this.state.mode !== "recover") &&
                        <Form.Control
                            type="password"
                            className={"formInput" + (this.state.invalidPassword ? " invalid" : "")}
                            placeholder="пароль"
                            onChange={(event) => { this.setState({ password: event.target.value, invalidPassword: false }); }}
                        />
                    }
                    <Button className="mainButton" type="submit" onClick={this.mainAction}>{this.state.mode === "login" ? "Войти" : (this.state.mode === "register" ? "Начать" : "Начать")}</Button>

                    <div className='secondButton' onClick={() => { this.setState({ mode: (this.state.mode === "login" ? "register" : "login") }); }}>
                        {this.state.mode === "login" ? "Регистрация" : "Вход на сайт"}
                    </div>

                    {(this.state.mode === "login") &&
                        <div className='secondButton' onClick={() => { this.setState({ mode: "recover" }); }}>
                            Сброс пароля
                        </div>
                    }
                </Form>
                {this.state.errorMessage &&
                    <p className="errorMessage">{this.state.errorMessage}</p>
                }
            </div>
        );
    }

}

export default LoginForm;